/*
 * @Author: Nanxing Xiang
 * @Date: 2021-01-19 09:56:36
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-09-02 14:43:54
 * @Description: file content
 */
import React, { lazy, Suspense, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { EasErrorBoundary, EasLoading } from '@easyvaas/react-components';
import config from './config';
import { getAppUserAgentInfo } from '@saturn/ua-parser';
import Routes from './routes';
import LocaleDetector from './components/LocaleDetector';
const client = getAppUserAgentInfo();
const supportShareAndRouteControl = (() => {
  if (!client) return false;
  if (client.version.major > 5) return true;
  return client.version.major === 5 && client.version.minor > 14;
})();

const ShareFramework = lazy(() => import('./components/ShareFramework'));
const RouteControlFramework = lazy(
  () => import('./components/RouteControlFramework')
);

const App: React.FC = () => {
  const shareable = useMemo(
    () =>
      supportShareAndRouteControl &&
      new URLSearchParams(window.location.search).get('shareable'),
    []
  );
  const routeControl = useMemo(
    () =>
      supportShareAndRouteControl &&
      new URLSearchParams(window.location.search).get('route_control'),
    []
  );
  return (
    <RecoilRoot>
      <BrowserRouter basename={config.baseUrl}>
        <LocaleDetector />
        <EasErrorBoundary>
          <Suspense fallback={<EasLoading type="dots" />}>
            <Routes />
          </Suspense>
        </EasErrorBoundary>
        <Suspense fallback={<div />}>
          {shareable && <ShareFramework />}
        </Suspense>
        <Suspense fallback={<div />}>
          {routeControl && <RouteControlFramework />}
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;
